export default __webpack_public_path__ + "./images/si.3e154043.png";